// Element registry. Add new entries here as `import { name } from './elements/name.js'`
// and include them in `listOfElements`. Elements follow the
// `{ selector, run(el, ctx, root), reactive? }` shape — see components for the pattern.
export const listOfElements = {};
